import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HardHat, Loader2, ArrowLeft } from 'lucide-react';
import api from '../api/client';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isLoading) return;
    setError(null);
    setIsLoading(true);

    try {
      await api.post('/api/v1/auth/forgot-password', { email });
      setSuccess(true);
      // Kullaniciyi sifre sifirlama sayfasina yonlendir, e-posta adresini aktar
      setTimeout(() => {
        navigate(`/reset-password?email=${encodeURIComponent(email)}`);
      }, 1500);
    } catch (err: unknown) {
      const axiosErr = err as {
        response?: { data?: { message?: string; error?: string } };
        message?: string;
      };
      let msg = 'İşlem sırasında bir hata oluştu. Lütfen tekrar deneyin.';
      if (axiosErr.response?.data?.message) {
        msg = axiosErr.response.data.message;
      } else if (axiosErr.response?.data?.error) {
        msg = axiosErr.response.data.error;
      } else if (axiosErr.message) {
        msg = axiosErr.message;
      }
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-lg">
        <div className="mb-8 flex flex-col items-center text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-xl bg-blue-600 text-white">
            <HardHat className="h-8 w-8" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900">Şifremi Unuttum</h1>
          <p className="mt-1 text-sm text-slate-500">
            E-posta adresinize doğrulama kodu gönderelim
          </p>
        </div>

        {error && (
          <div
            data-testid="forgot-error-message"
            className="mb-4 rounded-lg bg-red-50 px-4 py-3 text-sm font-medium text-red-700"
          >
            {error}
          </div>
        )}

        {success && (
          <div
            data-testid="forgot-success-message"
            className="mb-4 rounded-lg bg-green-50 px-4 py-3 text-sm font-medium text-green-700"
          >
            Doğrulama kodu gönderildi. Şifre sıfırlama sayfasına yönlendiriliyorsunuz...
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="email"
              className="mb-1 block text-sm font-medium text-slate-700"
            >
              E-posta
            </label>
            <input
              id="email"
              data-testid="forgot-email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 placeholder-slate-400 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              placeholder="ornek@rizmir.com"
            />
          </div>

          <button
            type="submit"
            data-testid="forgot-submit-button"
            disabled={isLoading || success}
            className="flex w-full items-center justify-center rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Gönderiliyor...
              </>
            ) : (
              'Doğrulama Kodu Gönder'
            )}
          </button>
        </form>

        <div className="mt-6 text-center">
          <Link
            to="/login"
            data-testid="forgot-back-to-login"
            className="inline-flex items-center text-sm font-medium text-blue-600 hover:text-blue-700"
          >
            <ArrowLeft className="mr-1 h-4 w-4" />
            Giriş sayfasına dön
          </Link>
        </div>
      </div>
    </div>
  );
}
